export default "__VITE_ASSET__CIAWE43B__"